import { render, staticRenderFns } from "./SuperadminDashboard.vue?vue&type=template&id=573cce98"
import script from "./SuperadminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperadminDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports